<template>
  <v-row dense class="stock-as-of-date-bar px-3 pt-3 pb-0" align="center">
    <v-col cols="12" sm="6" md="4" lg="3">
      <DatePicker
        :value="value"
        :label="$t('STOCK.INVENTORY.AS_OF_DATE')"
        :without-hint="true"
        @input="$emit('input', $event)"
      />
    </v-col>
    <v-col v-if="hint" cols="12" sm="6" md="8" lg="9">
      <span class="text-caption grey--text text--darken-1">{{ hint }}</span>
    </v-col>
  </v-row>
</template>

<script>
import DatePicker from "@/views/partials/form/DatePicker.vue";

export default {
  name: "StockAsOfDateBar",
  components: { DatePicker },
  props: {
    value: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: "",
    },
  },
};
</script>
